export const SOFTWARE_COLORIS = "coloris";
export const SOFTWARE_GAMMA = "ig";
export const SOFTWARE_LIGHT = "light";
export const SOFTWARE_REDLIKE = "redlike";
export const SOFTWARE_WEBER = "weber";

export const MODULE_REDLIKE = "redlike";
export const MODULE_FRONTDESK = "frontdesk";
export const MODULE_MACHINE = "machine";
export const MODULE_RCC = "RCC";
export const MODULE_COLORINVENT_MATCHING = "redlike_colorinvent_matching";
export const MODULE_DATACOLOR_MATCHING = "redlike_datacolor_matching";
export const MODULE_PACKAGE_CHECK = "redlike_servind_check_package";
export const MODULE_PARTIAL_UPDATES = "redlike_partial_updates";
export const MODULE_PRODUCT_GROUPS = "redlike_product_groups";
export const MODULE_TICKETING = "redlike_ticketing";

export const SUPPORTED_MODULES = [
    MODULE_COLORINVENT_MATCHING,
    MODULE_DATACOLOR_MATCHING,
    MODULE_PACKAGE_CHECK,
    MODULE_PARTIAL_UPDATES,
    MODULE_PRODUCT_GROUPS,
    MODULE_TICKETING
];

export const MODULE_MATCHING_REGEX = /redlike_.*_matching/g;

export const BUILD_STABLE = "stable";
export const BUILD_NIGHTLY = "nightly";
export const BUILD_DEV = "dev";

export const NIGHTLY_BUILD_LABEL = "NIGHTLY BUILD";
